
export default {
  props: { primary: { type: Object, default: () => {} } },

  data: () => ({ showStoreDetails: true }),

  computed: {
    formattedAddress() {
      return this.primary?.formatted_address ?? "";
    },
  },
};
